module.exports = __webpack_public_path__ + "static/media/andrealonso.9dee84ad.svg";